import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLimit = (store: StoreSchema) => store.instances.limit
export const selectPage = (store: StoreSchema) => store.instances.paginatedInstances.currentPage
export const selectTotalCount = (store: StoreSchema) => store.instances.paginatedInstances.totalCount